import * as tslib_1 from "tslib";
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["REQUESTED"] = "requested";
    OrderStatus["REGISTERED"] = "registered";
    OrderStatus["IN_PROGRESS"] = "inprogress";
    OrderStatus["DONE"] = "done";
    OrderStatus["READY_ACCOUNTING"] = "ready_accounting";
    OrderStatus["INVOICE_ISSUED"] = "invoice_issued";
    OrderStatus["PAID"] = "paid";
    OrderStatus["CANCELLED"] = "cancelled";
})(OrderStatus || (OrderStatus = {}));
var Order = /** @class */ (function () {
    function Order() {
    }
    return Order;
}());
export { Order };
var FlattenOrder = /** @class */ (function (_super) {
    tslib_1.__extends(FlattenOrder, _super);
    function FlattenOrder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FlattenOrder;
}(Order));
export { FlattenOrder };
